/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from '../../application';
import { LoggerModule } from '@vlinder-web/logger-module-react';
import { getAgent } from './agent';

const is = require('is_js');

const SERVICE_NAME = 'VerifyProductPageService';
const log: any = LoggerModule.getInstance();

export class VerifyProductPageService {
  private static instance: VerifyProductPageService;
  private vapp: VApplication;
  private fullProvenanceRestAPI: string;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.fullProvenanceRestAPI = props?.fullProvenanceRestAPI;
  }

  public static getInstance(props: any = {}): VerifyProductPageService {
    if (!VerifyProductPageService.instance) {
      VerifyProductPageService.instance = new VerifyProductPageService(props);
    }
    return VerifyProductPageService.instance;
  }

  public async getHeaderNavItems() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    compProps = await agent.getHeaderNavContent({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    console.log(`content in Header service`, compProps);
    return content;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent(args: any) {
    let content: any = {};
    let _args = {
      ...args,
      apiURL: this.fullProvenanceRestAPI,

      //headers: this.headers
    };
    const agent = getAgent();

    //Header Props

    //Feature Section Props
    content = await agent.getFeatureSectionProps(_args);

    return content;
  }

  public async tosProduct(args: any) {
    console.log(` in index of service :`);
    let _args = {
      ...args,
      apiURL: this.fullProvenanceRestAPI,

      //headers: this.headers
    };
    const agent = getAgent();
    return agent.tosProduct(_args);
  }

  public async onFeedbackSubmit(args: any) {
    let _args = {
      ...args,
      apiURL: this.fullProvenanceRestAPI,
    };
    const agent = getAgent();
    return agent.onFeedbackSubmit(_args);
  }
}
